// ImportLoadingModal — brief 84 band B, candidate B60.
// The "Reading file…" placeholder the import dialogs render before parsing
// lands. Four census copies were AST-identical (cc.import.reading_file); the
// jurisdiction import's copy reads a DIFFERENT key (ju.import.reading) — a
// hunk with no parameter — and stays in src/App.tsx, reported, per
// move-integrity-standard 1b.
import { ModalLayout } from "./SharedUI";
import { FS } from "../lib/tokens";

export function ImportLoadingModal({ t }: any) {
  return (
    <ModalLayout hideHeader footer={null} maxWidth={400}>
      <p style={{ fontSize: FS.s11, color: "var(--tm)" }}>
        {t("cc.import.reading_file", { fallback: "Reading file…" })}
      </p>
    </ModalLayout>
  );
}
